import React from 'react';
import { Input } from '@/components/ui/input';

const UploadInput = ({
						 label,
						 onChange,
					 }: {
	label: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
	return (
		<label className="block">
			<span className="block text-lg font-semibold mb-2">{label}</span>
			<Input
				type="file"
				multiple
				onChange={onChange}
				className="w-full p-2 border border-gray-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
			/>
		</label>
	);
};

export default UploadInput;
